import React from 'react';
import { Switch, Route } from 'react-router-dom';
import UsersList from './UsersList';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/users">
      <UsersList />
    </Route>
  </Switch>
);
export default Routes;
